import React from 'react';

import Link from '@atlaskit/link';

export const smartLinkFallback = (url: string) => () => (
	<Link href={url} target="_blank" rel="noopener noreferrer">
		{url}
	</Link>
);
